import { FetchSiteOptionsResponse } from 'services/content/site-options/types'

export default (data: FetchSiteOptionsResponse) => {
  const {
    brandBarLabelText,
    datePicker,
    desktopLogoWidth,
    findABox,
    headerLabelText,
    logoFile: { url: logoURI },
    logoLabelText,
    mainMenuLabelText,
    menuText,
    search,
  } = data.header

  return {
    brandBarLabelText,
    datePicker,
    desktopLogoWidth,
    findABoxLink: {
      url: findABox.findABoxLinkUrl,
      text: findABox.findABoxLinkText,
    },
    headerLabelText,
    logoLabelText,
    logoURI,
    mainMenuLabelText,
    menuText,
    search: {
      submitButtonText: search.searchActionText,
      searchResultsLabelText: search.searchResultsLabelText,
      searchTitleText: search.searchTitle,
    },
  }
}
